export const FILE_ACTIONS = {
  Download: 'download',
  View: 'view',
  Delete: 'delete',
  MoveTo: 'moveTo'
};
